import { PaginationRequest, UserFilterDTO } from '@vaneauneuf/dtos'
import Form from 'antd/lib/form'
import Select from 'antd/lib/select'
import React, { useState } from 'react'
import ContactsExport from './ContactsExport/ContactsExport'
import ContactsFilter from './ContactsFilter/ContactsFilter'
import styles from './ContactsPage.module.scss'
import ContactsTable from './ContactsTable/ContactsTable'

const ContactsPage: React.FC = () => {
  const [itemsPerPage, setItemsPerPage] = useState<number>(50)
  const [filters, setFilters] = useState<UserFilterDTO & PaginationRequest>({
    phone: '',
    name: '',
    email: '',
    onlyContact: true,
    order: { createDate: 'DESC' }
  })

  const tableTitle = (
    <Form layout="inline">
      <Form.Item label="Nombre de lignes par page">
        <Select value={itemsPerPage} onChange={setItemsPerPage}>
          {[10, 20, 50, 100, 200, 500].map(count => (
            <Select.Option key={`${count}`} value={count}>
              {count}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  )

  return (
    <div className={styles.container}>
      <h1>Contacts</h1>
      <ContactsExport />
      <ContactsFilter filters={filters} onUpdateFilters={setFilters} itemsPerPage={itemsPerPage} />
      <ContactsTable
        filters={filters}
        onUpdateFilters={setFilters}
        tableTitle={tableTitle}
        itemsPerPage={itemsPerPage}
      />
    </div>
  )
}

export default ContactsPage
